let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("6z6cv")).then(() => parcelRequire('1yifm'));